"use client"

import { useEffect } from "react"
import { useSearchParams } from "next/navigation"

export function ReferralCapture() {
  const params = useSearchParams()
  useEffect(() => {
    const ref = params.get("ref")
    if (ref) localStorage.setItem("algoglide_referral_code", ref)
  }, [params])
  return null
}
